// DateTimePickerField.tsx
import React from 'react';
import { FieldProps } from 'formik';
import DateTimePicker from './DateAndTimePicker'; // Your existing component

interface DateTimePickerFieldProps extends FieldProps {
  placeholder?: string;
  minDate?: Date;
  maxDate?: Date;
  className?: string;
}

const DateTimePickerField: React.FC<DateTimePickerFieldProps> = ({
  field,
  form,
  placeholder,
  minDate,
  maxDate,
  className,
}) => {
  return (
    <DateTimePicker
      value={field.value}
      onChange={(val) => form.setFieldValue(field.name, val)}
      placeholder={placeholder}
      minDate={minDate}
      maxDate={maxDate}
      className={className}
    />
  );
};

export default DateTimePickerField;



// import React, { useRef } from 'react'
// import DatePicker from 'react-datepicker'
// import { FieldProps } from 'formik'
// import 'react-datepicker/dist/react-datepicker.css'

// const CustomInput = React.forwardRef(({ value, onClick }: any, ref: any) => (
//   <button type="button" className="form-control text-start" onClick={onClick} ref={ref}>
//     {value || 'Select date & time'}
//   </button>
// ))

// const DateTimePickerField: React.FC<
//   FieldProps & { className?: string; max?: Date; min?: Date }
// > = ({ field, form, className, max, min }) => {
//   const selected = field.value ? new Date(field.value) : null

//   return (
//     <DatePicker
//       selected={selected}
//       onChange={(val) => form.setFieldValue(field.name, val)}
//       showTimeSelect
//       showTimeInput
//       timeIntervals={5}
//       dateFormat="yyyy-MM-dd HH:mm"
//       placeholderText="Select date & time"
//       className={className}
//       calendarClassName="shadow border"
//       wrapperClassName="w-100"
//       autoComplete="off"
//       customInput={<CustomInput />}
//       maxDate={max}
//       minDate={min}
//     />
//   )
// }

// export default DateTimePickerField
